import styled from "styled-components";
import { RegistrationContainer, RegistrationHeading, RegistrationSubHeading, } from 'pages/registration/registration.styles';

export const SubscriptionContainer = styled(RegistrationContainer)``;

export const SubscriptionHeading = styled(RegistrationHeading)``;

export const SubscriptionSubHeading = styled(RegistrationSubHeading)``;

export const SubscriptionCardContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 20px;
`;

export const SubscriptionCardInnerHeadingContainer = styled.div`
    width: 100%;
    height: 103px;
    color: white;
    background-color: ${props => props.background ? props.background : 'none'};
`;

export const SubscriptionCardInnerHeading = styled.div`
    padding-top: 25px;
    text-align: center;
    font-family: RubikMedium;
    font-size: 20px;
`;

export const SubscriptionCardInnerSubHeading = styled.div`
    padding-top: 10px;
    text-align: center;
    font-family: RubikMedium;
    font-size: 16px;
`;

export const SubscriptionCardInnerDescription = styled.div`
    margin: 30px;
    text-align: center;
    font-family: RubikRegular;
    color: #A5B5AF;
    font-size: 16px;
    line-height: 20px;
`;

export const SubscriptionCardInnerBenefitsList = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 30px;
`;

export const SubscriptionCardInnerBenefitsListItem = styled.div`
    display: flex;
    flex-direction: row;
    width: 260px;
    font-family: RubikRegular;
    font-size: 16px;
    color: #44554C;
    margin-bottom: 15px;
`;

export const SubscriptionCardInnerBenefitsListItemCheck = styled.img`
    padding-right: 10px;
    width: 16px;
`;

export const SubscriptionCardInnerButtonContainer = styled.div`
    margin: 30px;
`;

export const SubscriptionCardInnerButtonIcon = styled.img`
    font-size: 20px;
    margin-right: 10px;
`;